import React from "react";

export const ModuleConfigContext = React.createContext(null);
